import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CategoryNavigation = ({ type = 'wallcoverings', currentLink = '' }) => {
  const location = useLocation();
  const currentPath = currentLink || location.pathname;

  const wallcoveringCategories = [
    { name: "Decorative", link: "/wallcoverings/decorative" },
    { name: "Abstract", link: "/wallcoverings/abstract" },
    { name: "Corporate", link: "/wallcoverings/corporate" },
    { name: "Kids", link: "/wallcoverings/kids" },
    { name: "Minimal & Pattern", link: "/wallcoverings/minimal%20and%20pattern" },
    // { name: "View All", link: "/wallcoverings" },
  ];

  const artprintCategories = [
    { name: "Abstract", link: "/artprints/abstract" },
    { name: "Decorative", link: "/artprints/decorative" },
    { name: "Exclusive", link: "/artprints/exclusive" },
    { name: "Landscape", link: "/artprints/landscape" },
    { name: "Set of 2 & 3", link: "/artprints/set%20of%202%20and%203" },
    // { name: "View All", link: "/artprints" },
  ];

  const exclusiveCategories = [
    { name: "Exclusive Hand Paintings", link: "/exclusivehandpaintings" },
    { name: "Wall Papers", link: "/wallcoverings" },
    { name: "Art Prints", link: "/artprints" },
  ];

  const categories =
    type === 'artprints'
      ? artprintCategories
      : type === 'exclusive'
        ? exclusiveCategories
        : wallcoveringCategories;

  const label =
    type === 'artprints'
      ? 'Explore Art Print Categories'
      : type === 'exclusive'
        ? 'Explore Other Collections'
        : 'Explore Wallpaper Categories';

  return (
    <div className="pt-6 w-full">
      <div className="flex items-center gap-2 mb-3.5 justify-center md:justify-start">
        <span className="w-2 h-2 rounded-full bg-yellow-600" />
        <span className="text-xs uppercase tracking-widest text-gray-500 font-sans font-medium">
          {label}
        </span>
      </div>

      <div className="flex flex-wrap gap-2 sm:gap-2.5 justify-center md:justify-start">
        {categories.map((cat) => {
          const isActive = currentPath === cat.link;
          return (
            <Link
              key={cat.link}
              to={cat.link}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`px-4 sm:px-5 py-2 sm:py-2.5 rounded-2xl font-serif text-xs sm:text-sm font-medium tracking-wide transition-all duration-300 border ${isActive
                  ? "bg-[#1E2837] text-white border-[#1E2837] shadow-md scale-105"
                  : "bg-[#F4F1EA] text-gray-700 border-[#E8E3D9] hover:bg-[#1E2837] hover:text-white hover:border-[#1E2837] hover:scale-105 shadow-2xs"
                }`}
            >
              {cat.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryNavigation;
